export const REGULATORY_COMPANY_COUNTRIES = {
  CHILE: 'CL',
  COLOMBIA: 'CO',
} as const;

export const REGULATORY_MESSAGES = {
  CHILE_GLOBAL_CARD_SA: 'Estás operando bajo Global Card SA',
  COLOMBIA_GLOBAL_81: 'Estás operando en Global Colombia 81',
} as const;